module.exports = __webpack_public_path__ + "static/omega_servis_logo-3d47d4430d7552232c1368c2579bf8ec.svg";